import React from 'react';
import SvgLeftArrowIcon from '../svg/LeftArrowIcon';
import SvgRightArrowIcon from '../svg/RightArrowIcon';
import { FormattedMessage } from 'react-intl';

/**
 * Component to create a pager for large sets of data
 * @param {number} props.totalLength - the total number of items to be displayed
 * @param {number} props.startValue - the index value for the first item to be displayed
 * @param {number} props.incrementValue - the number of items to be displayed on each page
 * @param {function} props.onClick - the function that will be called when the user clicks on either of the links in the pager.
 */
function Pager(props) {
  let displayPrevious = true;
  let displayNext = true;

  const { totalLength, startValue, incrementValue, onClick } = props;

  let startNumber = 1;
  if (startValue >= 0) {
    startNumber = startValue + 1;
  }
  if (startValue <= 0) {
    startNumber = 1;
  }
  let incrementNum = incrementValue;
  if (typeof incrementValue === 'string') {
    incrementNum = parseInt(incrementValue, 10);
  }

  let endNum = startValue + incrementNum;
  if (endNum > totalLength) {
    endNum = totalLength;
  }

  // calculate the starting index number for the next page
  const nextPageStart = startValue + incrementNum;
  if (nextPageStart >= totalLength) {
    displayNext = false;
  } else {
    displayNext = true;
  }

  // calculate the starting index number for the previous page
  const prevPageStart = startValue - incrementNum;
  if (prevPageStart < 0 && Math.abs(prevPageStart) >= incrementNum) {
    displayPrevious = false;
  } else {
    displayPrevious = true;
  }

  function increment() {
    onClick(nextPageStart);
  }

  function decrement() {
    onClick(prevPageStart);
  }

  return (
    <div className="width-100 flex-around">
      <div className="align-center text-large" data-test="pager">
        {displayPrevious ? (
          <SvgLeftArrowIcon
            onClick={decrement}
            className="cursor-pointer margin-right-10 text-extra-large"
            data-test="left-arrow"
          />
        ) : (
          ''
        )}
        <strong className="margin-right-5" data-test="page-values-number">
          {startNumber} - {endNum}
        </strong>
        <FormattedMessage
          id="pager.ofText"
          defaultMessage="of"
          description="The pager display: '1 of 3'"
        />
        <strong className="margin-left-5" data-test="total-number">
          {totalLength}
        </strong>
        {displayNext ? (
          <SvgRightArrowIcon
            onClick={increment}
            className="cursor-pointer margin-left-10 text-extra-large"
            data-test="right-arrow"
          />
        ) : (
          ''
        )}
      </div>
    </div>
  );
}

export default Pager;
